module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('h1', {
    staticClass: "book-title"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _c('a', {
    attrs: {
      "id": "title"
    }
  }), _vm._v("The F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORBIDDEN")])]), _vm._v(" "), _c('p', {
    staticClass: "sub-title"
  }, [_c('em', [_vm._v("A VAMPIRE HUNTRESS LEGEND")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/publisher.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("L. A. BANKS")]), _vm._v(" "), _c('p', {
    staticClass: "editor"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/author.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("ST. MARTIN’S GRIFFIN")]), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/author1.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("NEW YORK")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73736436","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/title.vue
// module id = 66
// module chunks = 0